import styled from "@emotion/styled";
import LabelComponent from "@components/form/Label";
import { theme } from "@styles/theme";
import ButtonComponent from "@components/Button";
import TextFieldComponent from "@components/form/TextField";
import TextAreaComponent from "@components/form/TextArea";
import { IColumnProps } from "@pages/NewPQRS/Step3/interface";
const { sm, md, lg, xl } = theme.breakpoints;
export const Container = styled.form`
  width: 100%;
  font-size: 16px;
  margin: 3em 0;
  @media (max-width: ${xl}) {
    font-size: 11px;
  }
  @media (max-width: ${lg}) {
    font-size: 14px;
  }
`;
export const Header = styled.div`
  width: 100%;
`;
export const TypeContainer = styled.div`
  width: 35%;
  display: flex;
  @media (max-width: ${md}) {
    width: 50%;
  }
  @media (max-width: ${sm}) {
    width: 80%;
  }
`;
export const LabelCase = styled.div`
  width: 60%;
  background: white;
  color: #6d6d6d;
  font-family: "Poppins Regular";
  padding: 1.1em 0;
  text-align: center;
  border-top-left-radius: 0.75em;
  font-size: 0.8em;
`;
export const TypeCase = styled.div`
  width: 40%;
  background: ${(props: { color: string }) => props.color};
  color: white;
  font-family: "Poppins Regular";
  padding: 1.1em 0;
  border-top-right-radius: 0.75em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9em;
`;

export const TypePersonContainer = styled.div`
  display: flex;
`;
export const TypePerson = styled.div`
  cursor: pointer;
  flex-grow: 1;
  text-align: center;
  background: ${(props: { selected: boolean }) =>
    props.selected ? "#90d1f4" : "#D8DDE1"};
  color: ${(props: { selected: boolean }) =>
    props.selected ? "white" : "#6D6D6D"};
  font-family: "Poppins Regular";
  padding: 0.9em;
  :last-of-type {
    border-top-right-radius: 1em;
  }
`;
export const Body = styled.div`
  width: 100%;
  padding: 2em 3em;
  background: white;
  box-sizing: border-box;
  @media (max-width: ${md}) {
    padding: 2em 1em;
  }
`;
export const Title = styled.div`
  color: #0085c8;
  font-family: "Poppins Medium";
  margin-bottom: 3em;
`;
export const Row = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: ${md}) {
    flex-direction: column-reverse;
  }
`;
export const Location = styled.div`
  width: 70%;
  margin-right: 2em;
  @media (max-width: ${md}) {
    width: initial;
    margin-right: 0;
  }
  @media (max-width: ${sm}) {
    margin-right: 0;
  }
`;

export const Contact = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 1em;
  box-sizing: border-box;
  flex-wrap: wrap;
  @media (max-width: ${md}) {
    width: initial;
    flex-direction: row;
    padding-left: 0;
  }
`;
export const Column = styled.div`
  display: flex;
  justify-content: space-between;
  width: ${({ width }: IColumnProps) => width ?? "initial"};
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: 2.5em;
  :nth-of-type(2) {
    margin-top: 0;
  }

  @media (max-width: ${md}) {
    align-items: center;
  }
  @media (max-width: ${sm}) {
    width: 100%;
  }
`;
export const TextField = styled(TextFieldComponent)`
  margin: 0.5em 0;
  font-size: 0.9em;
  border-radius: 0.5em;
`;

export const Label = styled(LabelComponent)`
  white-space: nowrap;
  position: relative;
  color: #6d6d6d;
  display: flex;
  flex-direction: column;
  font-family: "Poppins Regular";
  width: ${({ width }: IColumnProps) => width ?? "26%"};
  @media (max-width: ${md}) {
    width: 45%;
    margin-bottom: 2em;
  }
  @media (max-width: ${sm}) {
    width: 100%;
  }
`;
export const TextArea = styled(TextAreaComponent)`
  margin-top: 0;
  @media (max-width: ${lg}) {
    width: 70%;
  }
  @media (max-width: ${md}) {
    margin: 1em auto;
    width: 100%;
  }
`;
export const Fotter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 3em;
  @media (max-width: ${lg}) {
    flex-wrap: wrap;
  }
`;
export const Instruction = styled.div`
  width: 46%;
  text-align: center;
  font-family: Poppins Ligth;
  font-size: 0.7em;
  color: #90d1f4;
  @media (max-width: ${lg}) {
    width: 100%;
    margin-bottom: 2.5em;
  }
`;
export const CurrentStep = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins Ligth;
  color: #0085c8;
  margin-right: 1em;
`;
export const Loading = styled.div`
  width: 7em;
  height: 0.5em;
  background-color: #e5e5e5;
`;
export const CurrentState = styled.div`
  width: 50%;
  background: #0085c8;
  height: 100%;
  border-radius: 0.5em;
`;
export const Button = styled(ButtonComponent)`
  margin: 0 2em;
  border-radius: 0.5em;
  padding: 0.5em 1em;
  @media (max-width: ${lg}) {
    margin-right: 0;
  }
  @media (max-width: ${sm}) {
    margin-top: 2em;
  }
`;
export const Line = styled.div`
  display: none;
  width: 100%;
  height: 1px;
  background-color: #d4d4d4;
  margin-bottom: 2em;
  @media (max-width: ${md}) {
    display: block;
  }
`;
